'use client'

import * as React from 'react'

import { captureWithSentry } from '~logic/sentry/captureWithSentry'

import { NOT_FOUND_REDIRECT_URL } from '../config/appConfig'

const OLD_URL_REGEX = new RegExp(
  /(?<brand>[a-z\-\d]+\.)+(?<application>[\w\-\.]+)\.(?<domain>\w{2,6})/,
)

export default function NotFound() {
  React.useEffect(() => {
    // if the app is in local mode, do not redirect
    if (process.env.NODE_ENV === `development`) {
      return
    }

    const url = window.location.href
    const isOldUrl = OLD_URL_REGEX.test(url)

    if (!isOldUrl) {
      window.location.replace(NOT_FOUND_REDIRECT_URL)
      return
    }

    captureWithSentry({ error: new Error(`Redirecting to new waiter app. Old URL: ${url}`) })

    const urlObject = new URL(url)
    const { host, pathname: localePathname } = urlObject

    // take brand from host and create new host without brand,
    // for example: sport-cafe.bez-fronty.dev.speedlo.cloud:
    //      brand: sport-cafe
    //      new host: bez-fronty.dev.speedlo.cloud
    const splitUrl = host.split('.')
    const brand = splitUrl.splice(0, 1)
    const newHost = splitUrl.join('.')

    // split pathname (contains "", "locale", "(branch)", "(sectors)")
    const splitPathname = localePathname.split('/')
    // remove empty field and locale from pathname
    splitPathname.splice(0, 2)
    // join pathname without locale
    const pathname = splitPathname.join('/')

    // create url for new waiter
    const newUrl = `https://${newHost}/waiter/${brand}/${pathname}`

    // redirect to new waiter app
    window.location.replace(newUrl)
  }, [])

  return null
}
